import { render, staticRenderFns } from "./o-list-news-v1.vue?vue&type=template&id=a7d7da96&scoped=true"
import script from "./o-list-news-v1.vue?vue&type=script&lang=js"
export * from "./o-list-news-v1.vue?vue&type=script&lang=js"
import style0 from "./o-list-news-v1.vue?vue&type=style&index=0&id=a7d7da96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d7da96",
  null
  
)

export default component.exports